import Phaser from "phaser";
import { SCALE, SCALE_RATIO, SCALE_V } from "./constants";
const fragShader = `
#define SHADER_NAME BLUR_FS

precision mediump float;

//"in" attributes from our vertex shader
varying vec2 outTexCoord;

//declare uniforms
uniform sampler2D uMainSampler;
uniform float uResolution;
uniform float radius;
uniform vec2 dir;

void main()
{
    //this will be our RGBA sum
    vec4 sum = vec4(0.0);

    //our original texcoord for this fragment
    vec2 tc = outTexCoord;

    //the amount to blur, i.e. how far off center to sample from
    //1.0 -> blur by one pixel
    //2.0 -> blur by two pixels, etc.
    float blur = radius/uResolution;

    //the direction of our blur
    //(1.0, 0.0) -> x-axis blur
    //(0.0, 1.0) -> y-axis blur
    float hstep = dir.x;
    float vstep = dir.y;

    //apply blurring, using a 9-tap filter with predefined gaussian weights",

    sum += texture2D(uMainSampler, vec2(tc.x - 4.0*blur*hstep, tc.y - 4.0*blur*vstep)) * 0.0162162162;
    sum += texture2D(uMainSampler, vec2(tc.x - 3.0*blur*hstep, tc.y - 3.0*blur*vstep)) * 0.0540540541;
    sum += texture2D(uMainSampler, vec2(tc.x - 2.0*blur*hstep, tc.y - 2.0*blur*vstep)) * 0.1216216216;
    sum += texture2D(uMainSampler, vec2(tc.x - 1.0*blur*hstep, tc.y - 1.0*blur*vstep)) * 0.1945945946;

    sum += texture2D(uMainSampler, vec2(tc.x, tc.y)) * 0.2270270270;

    sum += texture2D(uMainSampler, vec2(tc.x + 1.0*blur*hstep, tc.y + 1.0*blur*vstep)) * 0.1945945946;
    sum += texture2D(uMainSampler, vec2(tc.x + 2.0*blur*hstep, tc.y + 2.0*blur*vstep)) * 0.1216216216;
    sum += texture2D(uMainSampler, vec2(tc.x + 3.0*blur*hstep, tc.y + 3.0*blur*vstep)) * 0.0540540541;
    sum += texture2D(uMainSampler, vec2(tc.x + 4.0*blur*hstep, tc.y + 4.0*blur*vstep)) * 0.0162162162;

    //discard alpha for our simple demo,return
    gl_FragColor =  vec4(sum.rgb, 1.0);
}
`;

const fragCRTShader = `
  #ifdef GL_ES
      precision highp float;
  #endif

  #define PI 3.1415926538

  // Samplers
  varying vec2 outTexCoord;
  uniform sampler2D uMainSampler;

  // Parameters
  uniform vec2 curvature;
  uniform vec2 screenResolution;
  uniform vec2 scanLineOpacity;
  uniform float vignetteOpacity;
  uniform float brightness;
  uniform float vignetteRoundness;


  vec2 curveRemapUV(vec2 uv)
  {
      // as we near the edge of our screen apply greater distortion using a sinusoid.

      uv = uv * 2.0 - 1.0;
  vec2 offset = abs(uv.yx) / vec2(curvature.x, curvature.y);
  uv = uv + uv * offset * offset;
  uv = uv * 0.5 + 0.5;
      return uv;
  }

  vec4 scanLineIntensity(float uv, float resolution, float opacity)
  {
      float intensity = sin(uv * resolution * PI * 2.0);
      intensity = ((0.5 * intensity) + 0.5) * 0.9 + 0.1;
      return vec4(vec3(pow(intensity, opacity)), 1.0);
  }

  vec4 vignetteIntensity(vec2 uv, vec2 resolution, float opacity, float roundness)
  {
      float intensity = uv.x * uv.y * (1.0 - uv.x) * (1.0 - uv.y);
      return vec4(vec3(clamp(pow((resolution.x / roundness) * intensity, opacity), 0.0, 1.0)), 1.0);
  }

  void main(void) 
  {
      vec2 remappedUV = curveRemapUV(vec2(outTexCoord.x, outTexCoord.y));
      vec4 baseColor = texture2D(uMainSampler, remappedUV);

      baseColor *= vignetteIntensity(remappedUV, screenResolution, vignetteOpacity, vignetteRoundness);

      baseColor *= scanLineIntensity(remappedUV.x, screenResolution.y, scanLineOpacity.x);
      baseColor *= scanLineIntensity(remappedUV.y, screenResolution.x, scanLineOpacity.y);

      baseColor *= vec4(vec3(brightness), 1.0);

      if (remappedUV.x < 0.0 || remappedUV.y < 0.0 || remappedUV.x > 1.0 || remappedUV.y > 1.0){
          gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
      } else {
          gl_FragColor = baseColor;
      }
  }
`;

export default class BlurPostFX extends Phaser.Renderer.WebGL.Pipelines
  .PostFXPipeline {
  constructor(game) {
    // super({game})
    super({
      game,
      renderTarget: true,
      fragShader: fragCRTShader,
      // uniforms: [
      //     'uProjectionMatrix',
      //     'uMainSampler',
      //     'uResolution',
      //     'radius',
      //     'dir'
      // ]
      uniforms: [
        // 'uProjectionMatrix',
        "uMainSampler",
        "curvature",
        "screenResolution",
        "scanLineOpacity",
        "vignetteOpacity",
        "brightness",
        "vignetteRoundness",
      ],
    });
    this.set2f("curvature", 6.0, 100.0);
    // this.set2f("curvature", 6.0, 6.0);
    // this.set2f("screenResolution", 320, 240);

    // const ratio = document.querySelector('canvas').width / document.querySelector('canvas').height
    // this.set2f("screenResolution", 1024 / ratio, 760 / ratio);
    // this.set2f("screenResolution", 640 / ratio, 480 / ratio);
    // this.set2f("screenResolution", 640 / SCALE_RATIO, 480 / SCALE_RATIO);
    // const w = document.querySelector("canvas").width;
    // const h = document.querySelector("canvas").height;
    const w = document.querySelector("#content").width;
    const h = document.querySelector("#content").height;
    this.set2f("screenResolution", w, h);
    this.set2f("scanLineOpacity", 0.5, 0.05);
    // this.set2f("scanLineOpacity", 0.25, 0.25);
    this.set1f("vignetteOpacity", 0.5);
    this.set1f("vignetteRoundness", 1.0);
    this.set1f("brightness", 1.25);

    window.document.querySelector('#content').style.marginLeft = 0
    window.document.querySelector('#content').style.marginTop = 0
  }

  onPreRender() {
    const ratio =
      document.querySelector("#content").width /
      document.querySelector("#content").height;
    this.set2f("screenResolution", 640, 480);
  }
}
